import axios from "axios";

// const NODE_ENV = process.env.NODE_ENV
// const SERVICE_URL =
//   NODE_ENV === 'development' ? '/' : process.env.VUE_APP_SERVICE_URL
console.log("NODE_ENV", process.env.NODE_ENV);
console.log("SERVICE_URL", process.env.VUE_APP_SERVICE_URL);
const isTest=false // 区分接口代理和环境部署
// 创建 axios 实例
const service = axios.create({
  baseURL:isTest?"/": process.env.VUE_APP_SERVICE_URL,
  withCredentials: true,
  traditional: true,
  timeout: 1000 * 60 * 5,
  changeOrigin: true,
  ws: true,
  headers: {
    "Content-Type": "application/json; charset=UTF-8"
  }
});
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  }


console.log("service", service);
// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = getCookie('authToken')
    console.log('authToken', token)
    if (token){
      config.headers['t'] = token
    } else {
      //this.$router.push("login");
      // window.location.href = "/login";


    }

    // 在发送请求之前做些什么
    // 可以在这里添加 token 等
    return config;
  },
  error => {
    // 对请求错误做些什么
    console.error(error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    if (response.data.code == 5) {
      // 弹出弹框
      alert("请重新登录");
      // 跳转到登录页面 使用router实现
    } else if (response.status === 200 || response.status === 304) {
      return response.data;
    }
  },
  error => {
    // 对响应错误做点什么
    console.error(error);
    return Promise.reject(error);
  }
);

const http = {
  get(url, params) {
    return service.get(url, params);
  },
  post(url, data) {
    return service.post(url, data);
  }
};

export default http;



// WEBPACK FOOTER //
// ./src/servies/http.js